import { render } from "./ComportementModal.vue?vue&type=template&id=0dc8319e&scoped=true"
import script from "./ComportementModal.vue?vue&type=script&lang=js"
export * from "./ComportementModal.vue?vue&type=script&lang=js"

import "./ComportementModal.vue?vue&type=style&index=0&id=0dc8319e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc8319e"]])

export default __exports__